module.exports = __webpack_public_path__ + "static/media/warning-icon.33e08377.png";